/* Moved out of snippets/ola-agent.liquid (speed pass, 25.10.2026): the same code, now a deferred file instead of 71 KB inline in every page. */
  (function () {
    var root = document.querySelector('[data-ola-agent]');
    if (!root || root.dataset.wired) return;
    root.dataset.wired = '1';

    var endpoint = root.dataset.endpoint;
    var panel = root.querySelector('[data-agent-panel]');
    var log = root.querySelector('[data-agent-log]');
    var form = root.querySelector('[data-agent-form]');
    var input = root.querySelector('[data-agent-input]');
    var send = form.querySelector('.ola-agent__send');
    var suggestBox = root.querySelector('[data-agent-suggest]');
    var heroProductTpl = root.querySelector('[data-agent-hero-product]');
    var heroHomeTpl = root.querySelector('[data-agent-hero-home]');
    var teaser = root.querySelector('[data-agent-teaser]');
    var ship = root.querySelector('[data-agent-ship]');
    var shipText = root.querySelector('[data-agent-ship-text]');
    var shipFill = root.querySelector('[data-agent-ship-fill]');

    // Published on the announcement bar and on every cart page. Named once here so the
    // strip and the shop cannot drift apart quietly.
    var FREE_SHIPPING_FROM = 249;

    /* THE NUMBER IS NOT THIS FILE'S TO CHOOSE.
       THE BUSINESS LINE, and the shop was running two of them.

       OLA-AGENT/src/handoff.js used 972508860114 and this file followed it, while the FAQ
       page and the contact page published 055-955-4928 as customer service. A shopper
       handed over from the chat and a shopper who read the FAQ were reaching two different
       phones, and only one of them is watched by the people who answer. The owner named
       055-955-4928 as the business line on 17.9.2026.

       Written once here and once in the panel's footer, which is Liquid markup and cannot
       read a JavaScript constant. Those are the only two places this file states it, and
       the Worker states it once, in handoff.js. */
    var WHATSAPP_NUMBER = '972559554928';

    var history = [];
    var busy = false;

    // A session id, so the rate limiter can tell two shoppers apart without knowing who
    // either of them is. Random, per tab, never sent anywhere else.
    var sessionId = null;
    try { sessionId = sessionStorage.getItem('olaAgentSession'); } catch (e) {}
    if (!sessionId) {
      sessionId = (crypto.randomUUID ? crypto.randomUUID() : String(Math.random())).slice(0, 32);
      try { sessionStorage.setItem('olaAgentSession', sessionId); } catch (e) {}
    }
    // "Has she been here before" is one bit, stored in her own browser, and it licenses a
    // warmer opening and nothing else. No identity, no history, nothing sent to anyone.
    var returning = false;
    try {
      returning = localStorage.getItem('olaSeen') === '1';
      localStorage.setItem('olaSeen', '1');
    } catch (e) {}

    /* WHICH PAGE SHE IS ON, AND WHETHER IT CARRIES THE DEMO VIDEO.

       Five of the nine products have a tutorial video and four do not, and for "how do I
       use this" a thirty second video beats any paragraph the advisor can write. Somebody
       has to know which products have one.

       It is read off the page rather than kept as a list in the Worker, because the page is
       the only copy of that fact that cannot go stale. sections/main-product.liquid renders
       the tutorial only when a video URL exists, from a video_tutorial block if Guy added
       one in the theme editor and otherwise from a per handle fallback in that same file.
       So the day Guy attaches a video to THE VELVET PUFF in the editor, this field starts
       saying true for it with no deploy in either repository. A list in the other repository
       would have gone on saying false until somebody remembered it existed.

       data-video-section is the hook rather than the id because it appears exactly once in
       the whole theme, and #video is a name any future section could take.

       Set ONLY on a product page. Everywhere else the question has no subject, and a flat
       false would read as "this product has no video" rather than "no product was asked
       about". An absent field is the honest shape for a question nobody asked. */
    function pageContext() {
      var ctx = { template: (document.body.className.match(/template-(\w+)/) || [])[1] || 'page' };
      var m = location.pathname.match(/\/products\/([^/?#]+)/);
      if (m) {
        ctx.product = decodeURIComponent(m[1]);
        ctx.hasVideo = !!document.querySelector('[data-video-section]');
      }
      return ctx;
    }

    function money(n) {
      var v = Number(n);
      if (!isFinite(v)) return '';
      return '₪' + (v % 1 === 0 ? String(v) : v.toFixed(2));
    }

    function scrollDown() { log.scrollTop = log.scrollHeight; }

    /* Bring the TOP of a new answer into view instead of the bottom of the panel.
       An answer of three lines followed by two product cards is taller than the panel, so
       scrolling to the bottom parked her on the cards with the words above the fold: she
       asked a question, the advisor answered, and she had to scroll UP to find out what it
       said. Anchoring to the top of the message means she starts reading at the first word
       and the cards are the thing she scrolls down to, which is also the right order for
       selling: the reason first, the button second. */
    function scrollToAnswer(el) {
      if (!el) return scrollDown();
      /* Two frames: the cards are appended right after the bubble, and measuring before
         they have laid out puts the anchor in the wrong place. */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var top = el.offsetTop - log.offsetTop - 8;
          /* Never scroll backwards. If the whole answer already fits below what she was
             reading, moving the panel at all is just a jolt. */
          log.scrollTop = Math.max(0, Math.min(top, log.scrollHeight - log.clientHeight));
        });
      });
    }

    /* ── THE FUNNEL, AND THE RULE THAT DECIDES WHO EARNED THE ADD ──────────────
       Guy asked who actually added to cart through the advisor. Until now the beacon
       carried a bare event name and nothing else, so the question could not be answered
       from it: an add made because the advisor recommended something looked exactly like
       an add that happened to occur while the panel was open. Five stages are reported
       now, and the last one carries a verdict rather than a coincidence:

         open · ask · cards_shown · card_tap · add_to_cart

       THE WINDOW. An add is the advisor's only when it came from a card the advisor put
       on screen in this conversation AND was tapped within ATTRIBUTION_WINDOW_S of that
       card being drawn. Thirty minutes, chosen because that is the inactivity gap
       Shopify's own reports use to end a session: this number and the shop's session
       numbers are then cut on the same clock and can be put side by side without a
       footnote. The clock starts on the CARD and not on the panel, so a card from her
       first question does not stay attributable because she asked something unrelated an
       hour later.

       WHY IT CANNOT OVER-CLAIM. Three things, and each closes a different door:

         The stamp is written at render time by the code path that built the element, so
         provenance is a fact about how the card came to exist and not an inference drawn
         from the page afterwards. There is no route by which a panel that merely happened
         to be open produces an attributed add.

         The product page's own card, cloned from Liquid into the opening, is stamped
         'hero' and is never attributed. The advisor did not choose that product, the page
         she was already standing on did. Folding it in would inflate the number with every
         shopper who would have bought anyway, and a number that flatters itself is worse
         than no number: Guy will be making decisions from this.

         An age that cannot be read is not attributed. An unknown age is precisely the case
         where over-claiming is easiest, so it is the case that loses.

       The age in seconds is reported on every tap and every add, which means the window is
       auditable rather than asserted: the log shows the real distribution, and Guy can cut
       it tighter afterwards without anyone redeploying this file. */
    var ATTRIBUTION_WINDOW_S = 30 * 60;

    /* The stamp, written once, at the moment a card appears, by whichever code path built
       it. Read later and never rewritten. */
    function stampCard(el, src) {
      if (!el) return;
      el.setAttribute('data-ola-src', src);
      el.setAttribute('data-ola-at', String(Date.now()));
    }

    /* Which card a tap came out of, and how old that card was when she tapped it.
       Returns null for anything that is not inside a stamped card, and that null is doing
       real work: it is what keeps a link inside an answer's own text, and the checkout
       link appended after a successful add, out of the funnel entirely. */
    function cardOrigin(el) {
      var card = el && el.closest ? el.closest('[data-ola-src]') : null;
      if (!card) return null;
      var at = Number(card.getAttribute('data-ola-at'));
      return {
        src: card.getAttribute('data-ola-src'),
        age: isFinite(at) && at > 0 ? Math.round((Date.now() - at) / 1000) : null,
      };
    }

    /* The verdict, in one place, so there is exactly one definition of "the advisor's". */
    function fromAgent(o) {
      return Boolean(o && o.src !== 'hero' && o.age !== null && o.age <= ATTRIBUTION_WINDOW_S);
    }

    /* One line to the Worker's log, fire and forget. keepalive so it survives the tap that
       navigates away, which is exactly the tap worth counting. Nothing identifying in it.

       `extra` carries the funnel's numbers and nothing else: a count, a value in agorot,
       the age of the card in seconds, the verdict. Deliberately no product handle and no
       variant id. This beacon has no session id by design, so every field on it is a tally
       dimension; a handle sitting next to a value and a server timestamp would quietly
       turn a counter into a record of what individual shoppers bought and when, which is a
       different kind of data than a count and not the one that was asked for.

       A null or undefined field is dropped rather than sent, so the Worker never has to
       tell "we did not measure this" apart from "this was zero". */
    function track(name, extra) {
      try {
        var body = {
          evt: name,
          template: pageContext().template,
          hasCart: lastCartCount > 0,
        };
        if (extra) {
          for (var k in extra) {
            if (extra[k] !== null && extra[k] !== undefined) body[k] = extra[k];
          }
        }
        fetch(endpoint + '/event', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          keepalive: true,
          body: JSON.stringify(body),
        }).catch(function () {});
        toShopAnalytics(name, body);
      } catch (e) {}
    }

    /* THE SHOP'S OWN ANALYTICS, and what a grep of this theme actually found.

       There is no gtag, no dataLayer and no analytics.publish anywhere in layout/,
       sections/, snippets/ or assets/. The only analytics on the page is Shopify's own,
       injected by the content_for_header tag in layout/theme.liquid, which is what defines
       window.Shopify.analytics.publish and the replayQueue that buffers calls made before
       the pixel manager has finished loading. Written without its braces on purpose:
       Liquid renders this file's script block too, so spelling that tag out here would
       have emptied Shopify's entire header payload into a JavaScript comment.

       GA4 is running, G-3SFG0BJEXP, but it arrives through the Google and YouTube channel's
       web pixel, which executes in the pixel sandbox. There is no page level gtag function
       to call, and defining one here would be installing a vendor rather than reporting to
       one. So the advisor publishes to Shopify and to nothing else.

       What that does and does not buy: publishing puts the event in the shop's customer
       events stream, where any pixel that subscribes to ola_agent_* can pick it up. It does
       NOT reach GA4 on its own. Wiring it onward is a decision about the shop's measurement
       and belongs to Guy, not to this file.

       The two detections below are guards, never installs. If a later theme edit adds a
       real gtag or dataLayer, the advisor's events join it without another edit here, and
       until that day neither branch runs. gtag wins over dataLayer where both exist,
       because under GTM gtag already pushes to dataLayer and firing both would double
       count the same add. */
    function toShopAnalytics(name, body) {
      try {
        var evt = 'ola_agent_' + name;
        var sa = window.Shopify && window.Shopify.analytics;
        if (sa && typeof sa.publish === 'function') sa.publish(evt, body);
        if (typeof window.gtag === 'function') window.gtag('event', evt, body);
        else if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: evt }, body));
      } catch (e) {}
    }

    /* What was actually added, in agorot, read from Shopify's own answer to the add.

       Not from the card. A card's price reaches this widget from the Storefront API as a
       decimal in shekels, and a funnel whose money is a number this file converted is a
       funnel that can drift from the money the shop took. final_line_price is what she was
       charged for that line after any cart level discount, in agorot, and it is the number
       Guy will be making decisions from.

       An unreadable response reports no value at all rather than a zero. A zero would be
       indistinguishable from a free item and would drag every average the Worker computes
       quietly downwards. */
    function addedValue(out) {
      var items = out && out.items ? out.items : (out && out.id ? [out] : []);
      var agorot = 0;
      var units = 0;
      for (var i = 0; i < items.length; i++) {
        var it = items[i] || {};
        var qty = Number(it.quantity) || 0;
        var line = Number(it.final_line_price);
        if (!isFinite(line)) line = (Number(it.final_price) || Number(it.price) || 0) * qty;
        if (isFinite(line) && line > 0) agorot += line;
        units += qty;
      }
      return { value: agorot > 0 ? Math.round(agorot) : null, n: units || null };
    }
    var lastCartCount = 0;

    /* A link in an answer has to be clickable, and it has to be clickable WITHOUT the answer
       becoming a place where markup can be injected. The whole message is written as text
       first, which is what makes it safe, and then only the runs that are literally an
       https address are replaced by an anchor built with createElement. Nothing from the
       model is ever parsed as HTML.
       This was not academic: the order tracking answer carries a real Cargo link, and it
       arrived as plain text that a shopper could look at and not open. */
    var URL_RE = /https?:\/\/[^\s<>"')\]]+/g;

    /* "כאן רואים את כל הסטטוס:" on one line and the address on the next. When the answer
       says what the link is, that sentence becomes the button and the address itself is
       never printed. */
    var LABEL_LINE = /(?:^|\n)([^\n]{2,40}):\n$/;

    /* A label names a link. A sentence that happens to end in a colon does not, and the
       difference matters because the matched line is REMOVED from the message: "זה לא לחץ,
       זו העובדה. הנה הקישור:" would have become a 40 pixel pill and the sentence before it
       would have vanished. A real label is short and has no sentence inside it. */
    function looksLikeLabel(line) {
      return line.length <= 40 && !/[.!?]/.test(line);
    }

    /* An address with no sentence above it still has to be readable. The host is the part
       a shopper recognises, and it beats a truncated token either way. */
    function shortHref(href) {
      if (href.length <= 46) return href;
      var host = href.replace(/^https?:\/\//, '').split('/')[0];
      return host || href.slice(0, 44);
    }

    function writeWithLinks(el, text) {
      var last = 0;
      var m;
      URL_RE.lastIndex = 0;
      while ((m = URL_RE.exec(text)) !== null) {
        var before = text.slice(last, m.index);
        var lm = before.match(LABEL_LINE);
        if (lm && !looksLikeLabel(lm[1].trim())) lm = null;
        var label = lm ? lm[1].trim() : '';
        if (lm) before = before.slice(0, before.length - (lm[1].length + 2));
        if (before) el.appendChild(document.createTextNode(before));
        var href = m[0].replace(/[.,;:]+$/, '');       // a full stop after a link is punctuation
        var a = document.createElement('a');
        a.className = 'ola-agent__link' + (label ? ' ola-agent__link--named' : '');
        a.href = href;

        /* A LINK INTO THE PAGE SHE IS ALREADY STANDING ON.
           The tutorial pointer is /products/<handle>#video, and on that product's own page
           the address is this exact page plus a fragment. Opened with target="_blank" it
           loads a SECOND COPY of the page she is already reading, in a tab whose
           sessionStorage is empty, so the conversation she was having does not come with
           her. On a phone that is worse than not answering at all. A link to this same path
           with a fragment therefore scrolls the page instead, and closes the panel, because
           the thing she asked to see is underneath it. Anything that really does go
           somewhere else keeps the new tab it has always had. */
        var hashHere = null;
        try {
          var u = new URL(href, location.href);
          if (u.origin === location.origin && u.pathname === location.pathname && u.hash.length > 1) {
            hashHere = decodeURIComponent(u.hash.slice(1));
          }
        } catch (err) {}

        if (!hashHere) {
          a.target = '_blank';
          a.rel = 'noopener noreferrer';
        }

        /* The tutorial pointer is worth counting on its own. Step one of what Guy asked for
           is that a shopper who does not know how to use something is sent to the video,
           and the only honest measure of whether that lands is how often the pointer is
           tapped. Named for the vocabulary the beacon already speaks, beside open, ask,
           card_tap and teaser_shown. `here` separates the two journeys hiding inside one
           number: she was already on that product's page and the tap only moved her down
           it, or she was somewhere else and the tap was a page change. keepalive on the
           beacon is what carries the second case across that change. */
        var isVideo = /#video$/i.test(href);
        if (isVideo || hashHere) {
          a.addEventListener('click', function () {
            if (isVideo) track('video_tap', { here: !!hashHere });
            /* Nothing calls preventDefault and nothing here scrolls anything.

               The browser's own fragment navigation is the most reliable scroll there is.
               It cannot stall the way an animated scroll can, which is not theoretical: a
               scrollIntoView with behavior 'smooth' was tried here first and, measured in a
               tab that was not being painted, it moved the page partway and stopped, with
               no error anywhere. It also cannot fight her if she starts scrolling herself
               mid flight, it puts #video in the address bar so Back brings her up the page
               again, and it takes its manner from the shop's own html { scroll-behavior },
               which is where every other anchor in this theme gets its manner from. A
               scroll written here would have to carry a second copy of that decision, and
               carrying a second copy of a decision is the thing this project keeps not
               doing.

               All that is left is to get the panel out of the way of what she asked to see,
               because on a phone it covers most of the screen. Only when the anchor really
               is on this page: a link to a section that is not here scrolls nowhere, and
               closing the chat for it would cost her the conversation for nothing. */
            if (hashHere && document.getElementById(hashHere)) close();
          });
        }

        a.textContent = label || shortHref(href);
        el.appendChild(a);
        last = m.index + href.length;
      }
      if (last < text.length) el.appendChild(document.createTextNode(text.slice(last)));
    }

    function bubble(text, who) {
      var el = document.createElement('div');
      el.className = 'ola-agent__msg ola-agent__msg--' + who;
      if (/https?:\/\//.test(text)) writeWithLinks(el, text);
      else el.textContent = text;
      log.appendChild(el);
      scrollDown();
      return el;
    }

    /* What it is actually doing while she waits.
       Every answer costs a live read of the shop and then the model, which is a few
       seconds of three dots and no reason to trust that anything is happening. The line
       is true: the prices and the stock really are being read at that moment. */
    var TYPING_LINES = [
      'בודקת מחיר ומלאי עכשיו',
      'רגע, מביאה את הנתונים מהחנות',
      'בודקת בשבילך',
    ];
    var typingLineIndex = 0;

    function typing(on) {
      var t = log.querySelector('.ola-agent__typing');
      if (on && !t) {
        t = document.createElement('div');
        t.className = 'ola-agent__typing';
        t.appendChild(document.createElement('i'));
        t.appendChild(document.createElement('i'));
        t.appendChild(document.createElement('i'));
        var say = document.createElement('span');
        say.className = 'ola-agent__typing-say';
        say.textContent = TYPING_LINES[typingLineIndex % TYPING_LINES.length];
        typingLineIndex++;
        t.appendChild(say);
        log.appendChild(t);
        scrollDown();
      } else if (!on && t) {
        t.remove();
      }
    }

    function chips(list) {
      suggestBox.textContent = '';
      list.forEach(function (q) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ola-agent__chip';
        b.textContent = q;
        b.addEventListener('click', function () { ask(q); });
        suggestBox.appendChild(b);
      });
    }

    /* ── product cards ───────────────────────────────────────────────────────
       Everything here is built with createElement and textContent. A product title
       is shop copy rather than shopper input, but this panel also prints text that
       passed through a language model, and the rule that nothing in here is ever
       assembled as HTML is the reason that distinction never has to be relied on. */
    function renderCards(list) {
      if (!list || !list.length) return;
      var wrap = document.createElement('div');
      wrap.className = 'ola-cards';
      /* Counted rather than taken from list.length: the loop below drops anything without
         a handle, and reporting cards that were never drawn would make the step from
         cards_shown to add_to_cart look worse than it is. */
      var shown = 0;

      list.forEach(function (p) {
        if (!p || !p.handle) return;
        var card = document.createElement('article');
        card.className = 'ola-card';

        if (p.image) {
          var media = document.createElement('a');
          media.className = 'ola-card__media';
          media.href = p.url;
          var img = document.createElement('img');
          img.src = p.image;
          img.alt = p.imageAlt || p.title;
          img.width = 74; img.height = 74;
          img.loading = 'lazy';
          media.appendChild(img);
          card.appendChild(media);
        }

        var body = document.createElement('div');
        body.className = 'ola-card__body';

        var title = document.createElement('div');
        title.className = 'ola-card__title';
        title.textContent = p.title;
        body.appendChild(title);

        if (p.subtitle) {
          var sub = document.createElement('div');
          sub.className = 'ola-card__sub';
          sub.textContent = p.subtitle;
          body.appendChild(sub);
        }

        if (p.contains && p.contains.length) {
          var cont = document.createElement('div');
          cont.className = 'ola-card__contains';
          cont.textContent = 'מכיל: ' + p.contains.join(', ');
          body.appendChild(cont);
        }

        var price = document.createElement('div');
        price.className = 'ola-card__price';
        price.appendChild(document.createTextNode(money(p.price)));
        if (p.compareAt) {
          var was = document.createElement('span');
          was.className = 'ola-card__was';
          was.textContent = money(p.compareAt);
          price.appendChild(was);
        }
        if (p.saving) {
          var save = document.createElement('span');
          save.className = 'ola-card__save';
          save.textContent = 'חיסכון ' + money(p.saving);
          price.appendChild(save);
        }
        body.appendChild(price);

        var row = document.createElement('div');
        row.className = 'ola-card__row';

        if (p.available && p.variantId) {
          var add = document.createElement('button');
          add.type = 'button';
          add.className = 'ola-card__add';
          add.textContent = 'להוספה לסל';
          add.addEventListener('click', function () { addFromCard(add, p); });
          row.appendChild(add);

          var link = document.createElement('a');
          link.className = 'ola-card__link';
          link.href = p.url;
          link.textContent = 'לפרטים';
          row.appendChild(link);
        } else {
          // Sold out. The back in stock form lives on the product page, so that is where
          // she is sent, and the card says why rather than offering a button that fails.
          var out = document.createElement('a');
          out.className = 'ola-card__out';
          out.href = p.url;
          out.textContent = 'אזל מהמלאי, לעדכון כשיחזור';
          row.appendChild(out);
        }

        body.appendChild(row);
        card.appendChild(body);
        /* Stamped here and nowhere else. This line is the single moment at which "the
           advisor chose to put this product in front of her" is true, and it is the
           timestamp the attribution window is measured from. */
        stampCard(card, 'card');
        shown += 1;
        wrap.appendChild(card);
      });

      log.appendChild(wrap);
      scrollDown();
      if (shown) track('cards_shown', { src: 'card', n: shown });
    }

    /* The thread survives a page change.
       She reads an answer, taps through to the product, and comes back: without this the
       conversation is gone and she has to start again. Only the words are kept. A card's
       price was true at the moment it was fetched, so a restored card would be a number
       nobody checked; cards are re-earned by asking again. */
    var STORE_KEY = 'olaAgentThread';
    /* Two small facts that let a conversation survive a page change.
       OPEN_KEY: the panel was open when she navigated, so it opens again on the next page.
       Without it, clicking through to another product from inside a conversation closed the
       advisor mid sentence and she had to find the bubble again.
       PAGE_KEY: which product she was on last, so arriving somewhere new can be noticed. */
    var OPEN_KEY = 'olaAgentOpen';
    var PAGE_KEY = 'olaAgentLastPage';

    function pageMark() {
      var c = pageContext();
      return c.product ? 'p:' + (root.dataset.productTitle || c.product) : 't:' + c.template;
    }
    function lastPageMark() {
      try { return sessionStorage.getItem(PAGE_KEY) || ''; } catch (e) { return ''; }
    }
    function rememberPage() {
      try { sessionStorage.setItem(PAGE_KEY, pageMark()); } catch (e) {}
    }

    /* Only real exchanges are kept. An error bubble restored from storage is worse than
       no memory at all: she reopens the panel, reads "משהו אצלי נתקע" from ten minutes
       ago, and concludes the shop is still broken when it recovered long since. */
    function saveThread() {
      try { sessionStorage.setItem(STORE_KEY, JSON.stringify(history.slice(-12))); } catch (e) {}
    }

    function resetThread() {
      /* Cancel first, then clear. The other order leaves a request in the air that lands in
         the conversation it was supposed to have ended. */
      turnSeq++;
      if (inflight) { try { inflight.abort(); } catch (e) {} inflight = null; }
      typing(false);
      history = [];
      try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
      /* The shop keeps notes on what she told it, so that the second answer is better than
         the first. "Start over" has to clear those too, or it quietly means "start over,
         except for the parts I kept". Fire and forget: the reset must feel instant, and a
         reset that half worked is still a cleared conversation in front of her. */
      try {
        fetch(endpoint + '/forget', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          keepalive: true,
          body: JSON.stringify({ sessionId: sessionId }),
        }).catch(function () {});
      } catch (e) {}
      log.textContent = '';
      suggestBox.textContent = '';
      busy = false;
      send.disabled = false;
      greet();
      input.focus();
    }
    function loadThread() {
      try {
        var raw = sessionStorage.getItem(STORE_KEY);
        var arr = raw ? JSON.parse(raw) : null;
        return Array.isArray(arr) ? arr : [];
      } catch (e) { return []; }
    }

    function renderShipping(cart) {
      if (!cart || !cart.item_count || typeof cart.total_price !== 'number') {
        ship.hidden = true;
        return;
      }
      var total = cart.total_price / 100;
      var gap = FREE_SHIPPING_FROM - total;
      if (gap <= 0) { ship.hidden = true; return; }
      shipText.textContent = '';
      shipText.appendChild(document.createTextNode('עוד '));
      var b = document.createElement('b');
      b.textContent = money(Math.ceil(gap));
      shipText.appendChild(b);
      shipText.appendChild(document.createTextNode(' למשלוח חינם'));
      shipFill.style.width = Math.max(4, Math.round((total / FREE_SHIPPING_FROM) * 100)) + '%';
      ship.hidden = false;
    }

    async function refreshShipping() {
      renderShipping(await cartNow());
    }

    /* The WhatsApp glyph, drawn rather than loaded, so the button never waits on a
       network request at the exact moment she has run out of patience. */
    function whatsappIcon() {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('width', '17');
      svg.setAttribute('height', '17');
      svg.setAttribute('fill', 'currentColor');
      svg.setAttribute('aria-hidden', 'true');
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute(
        'd',
        'M12 2a10 10 0 0 0-8.6 15L2 22l5.2-1.4A10 10 0 1 0 12 2zm0 1.8a8.2 8.2 0 1 1-4.2 15.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 0 1 12 3.8zm-3.1 4c-.2 0-.5.1-.7.4-.2.3-.9.9-.9 2.1s.9 2.4 1 2.6c.1.2 1.7 2.7 4.2 3.7 2 .8 2.4.6 2.9.6.4 0 1.4-.6 1.6-1.2.2-.6.2-1 .1-1.1l-.6-.3-1.4-.7c-.2-.1-.4-.1-.5.1l-.7.9c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-2-1.2 7.4 7.4 0 0 1-1.3-1.7c-.1-.2 0-.4.1-.5l.4-.5.3-.5v-.4l-.7-1.7c-.2-.4-.4-.4-.5-.4z'
      );
      svg.appendChild(path);
      return svg;
    }

    /* THE MESSAGE SHE IS ABOUT TO SEND, READ BACK OUT OF THE LINK ITSELF.

       Not out of a separate field. The only text WhatsApp will ever receive is the one
       encoded in the url's text parameter, so that is the only text it is honest to show
       her: a second field carrying "the message" could disagree with the link by one word
       and she would be reading something other than what she sends. This is the exact
       inverse of the encodeURIComponent that built it.

       Hand written rather than URLSearchParams, which decodes + as a space. A literal plus
       is rare in Hebrew but a message that silently loses a character is precisely the
       thing this display exists to rule out. */
    function prefillOf(url) {
      try {
        var q = String(url || '').split('?')[1];
        if (!q) return '';
        var parts = q.split('&');
        for (var i = 0; i < parts.length; i++) {
          if (parts[i].slice(0, 5) === 'text=') return decodeURIComponent(parts[i].slice(5));
        }
      } catch (e) {}
      return '';
    }

    /* THE DOOR TO A PERSON, WITH THE MESSAGE ALREADY WRITTEN AND VISIBLE.

       What Guy asked for is a button she presses once, with the words already inside it, so
       the shop answers her on WhatsApp instead of her starting over there. The button did
       carry a prefill before this, but nothing on screen said so: from her side it was an
       anchor that opened a chat, and the sentence appeared only after she had already left
       the shop. A button that fires a message she has not read is not what he asked for, so
       the message is printed above it, verbatim.

       WHAT THE LINK ACTUALLY DOES ON A PHONE, which is the case that matters here. wa.me is
       a redirector: on a mobile browser it hands off to the WhatsApp app with the number and
       the text, and the text lands in the input box UNSENT, with her thumb over send. That
       is the whole behaviour Guy described, and it is WhatsApp's, not ours. Nothing in this
       file can send a message on her behalf and nothing here tries.

       target and rel, checked rather than assumed:
         target="_blank" stays. It is a different origin and a different app, and a tap that
         replaced the shop tab would take the conversation with it.
         rel is now "noopener noreferrer", matching the links inside answers. noopener was
         already here; noreferrer stops the page address being handed to wa.me in a header
         as well, and she loses nothing by it because the link carries what it needs.
       The click path is clear: the delegated listener on the log reads a card stamp, this
       box has none, so it returns before doing anything, and nothing anywhere calls
       preventDefault on this anchor. */
    function renderHandoff(h) {
      if (!h || !h.url) return;
      var box = document.createElement('div');
      box.className = 'ola-handoff';

      if (h.note) {
        var note = document.createElement('div');
        note.className = 'ola-handoff__note';
        note.textContent = h.note;
        box.appendChild(note);
      }

      var prefill = prefillOf(h.url);
      if (prefill) {
        var msg = document.createElement('div');
        msg.className = 'ola-handoff__msg';
        msg.textContent = prefill;
        box.appendChild(msg);

        /* Said plainly, because the difference between "this opens a draft" and "this sends
           something" is the difference between a button she taps and one she does not. */
        var hint = document.createElement('div');
        hint.className = 'ola-handoff__hint';
        hint.textContent = 'ההודעה כבר כתובה. היא נפתחת אצלך בוואטסאפ ונשלחת רק כשתלחצי שליחה.';
        box.appendChild(hint);
      }

      var a = document.createElement('a');
      a.className = 'ola-handoff__btn';
      a.href = h.url;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.appendChild(whatsappIcon());
      a.appendChild(document.createTextNode(h.label || 'לדבר עם נציגה בוואטסאפ'));
      /* The two stages of the door, in the beacon's existing vocabulary: cards_shown and
         card_tap already name a thing put on screen and a thing tapped, so these are
         handoff_shown and handoff_tap. `reason` is the Worker's own word for why the door
         appeared, how_to or asked or order or blocked or error or sensitive, which is what
         turns the pair into an answer about WHERE the site is failing her and not only how
         often. how_to is the one Guy asked this work for, and it is the one to read first:
         it counts the shoppers the site could not teach.
         `prefilled` says whether there was a message to read, so a regression that empties
         the prefill shows up as a number rather than as silence. Both are tallies and
         neither carries anything about her. */
      a.addEventListener('click', function () {
        track('handoff_tap', { reason: h.reason || null, prefilled: !!prefill });
      });
      box.appendChild(a);

      log.appendChild(box);
      scrollDown();
      track('handoff_shown', { reason: h.reason || null, prefilled: !!prefill });
    }

    /* THIS FALLBACK NO LONGER QUOTES HER, AND THAT IS DELIBERATE.

       It used to build its own prefill: her question through askedLine(), which is a trim
       and a 160 cap, plus location.href. The Worker's askedText() does considerably more
       than that, and for reasons that were each found by attacking it: it folds characters
       before deciding what is a link, so a domain written with an ellipsis cannot be
       reassembled into a working one; it strips any dotted host rather than a list of
       endings, so evil.ai does not survive; it folds digits before counting them, so a
       phone number written with hyphens or in Arabic-Indic digits cannot travel; and it
       removes control and format characters, so an invisible reorder cannot change what the
       person on the other side reads.

       None of that ran here. Two implementations of one rule is the shape BRAIN.md calls a
       bug waiting to happen, and this one runs exactly when the Worker is unreachable,
       which is when nobody is watching.

       So this path quotes nothing. It opens a conversation with the shop and names the
       product she was looking at, which is a fact this page already published in its own
       markup, and it does not carry her words or her URL. She types what she wants in
       WhatsApp, where she can see it. A shorter opening line is a small loss; a second
       sanitiser that drifts from the first is not a small risk. */
    function localHandoff(question, note) {
      var title = root.dataset.productTitle || '';
      var lines = [title ? 'היי, אשמח לעזרה והסבר על ' + title + ' ואיך משתמשים.' : 'היי, הגעתי מהאתר ואשמח לעזרה.'];
      return {
        reason: 'error',
        note: note,
        label: 'לדבר עם נציגה בוואטסאפ',
        url: 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + encodeURIComponent(lines.join('\n')),
      };
    }

    /* Real reviews for the product she is looking at, read from the same Flashy widget
       the page itself renders. Fetched once per page and reused, because the answer does
       not change between her questions and she should not wait for it twice.

       Flashy's script is injected by the app and lands well after DOMContentLoaded, so
       this waits for it rather than assuming. If it never arrives, the agent simply has
       no reviews that turn, which is a quieter answer and not a broken one. */
    var reviewsCache = null;

    function flashyReady(tries) {
      return new Promise(function (resolve) {
        (function poll(n) {
          if (window.flashy && window.flashy.reviews && typeof window.flashy.reviews.get === 'function') {
            return resolve(true);
          }
          if (n > 24) return resolve(false);
          setTimeout(function () { poll(n + 1); }, 250);
        })(tries || 0);
      });
    }

    async function reviewsNow() {
      if (reviewsCache) return reviewsCache;
      var productId = root.dataset.productId;
      if (!productId) return [];
      /* Cached on the MISS too. flashyReady polls 25 times at 250ms, so when the reviews
         app is blocked by an ad blocker or simply absent this waited six seconds before the
         request even left the browser, and it did that again for every single message she
         sent, because reviewsCache was only ever written on the success path. */
      if (!(await flashyReady(0))) { reviewsCache = []; return reviewsCache; }
      try {
        var res = await Promise.resolve(window.flashy.reviews.get(String(productId), 8, 1));
        var list = (res && res.results) || [];
        /* Not every review is worth quoting. On STARTER the three real ones are
           "לא ניסיתי אבל נראה טוב", "מושלם אין דברים כאלה", and a long one that names the
           exact objections a shopper has: it does not stain, it is not orange, it does not
           come off in patches. Only the third is worth anything in a sales conversation.
           Length is a crude proxy for substance and it picks the right one here, so the
           longest four at four stars or more are what travel. */
        reviewsCache = list
          .filter(function (r) {
            return r && r.review && Number(r.stars || 5) >= 4 && String(r.review).trim().length >= 40;
          })
          .sort(function (a, b) { return String(b.review).length - String(a.review).length; })
          .slice(0, 3)
          .map(function (r) {
            return {
              stars: Number(r.stars || 5),
              name: String(r.name || 'לקוחה'),
              review: String(r.review).trim(),
            };
          });
        return reviewsCache;
      } catch (e) {
        return [];
      }
    }

    /* Her basket, drawn inside the conversation.
       At the moment she is deciding whether to finish, the useful thing is not another
       product, it is what she has already chosen, what it costs, and one button. She had
       to leave the chat to see any of it, and leaving is the thing we are trying to
       prevent. Built from /cart.js, so the prices are Shopify's own and it needs no
       network call beyond the one already made. */
    function renderCartCard(cart) {
      if (!cart || !cart.item_count) return;
      var box = document.createElement('div');
      box.className = 'ola-basket';

      var head = document.createElement('div');
      head.className = 'ola-basket__head';
      head.textContent = 'בסל שלך';
      box.appendChild(head);

      (cart.items || []).slice(0, 4).forEach(function (it) {
        var row = document.createElement('div');
        row.className = 'ola-basket__row';

        if (it.image) {
          var img = document.createElement('img');
          img.className = 'ola-basket__img';
          img.src = it.image.replace(/(\.[a-z]+)(\?|$)/i, '_80x$1$2');
          img.alt = '';
          img.width = 34; img.height = 34; img.loading = 'lazy';
          row.appendChild(img);
        }

        var name = document.createElement('span');
        name.className = 'ola-basket__name';
        name.textContent = it.quantity > 1 ? it.title + ' x' + it.quantity : it.title;
        row.appendChild(name);

        var price = document.createElement('span');
        price.className = 'ola-basket__price';
        // The free gift reads as a mistake at ₪0. It is a gift, so it says so.
        price.textContent = it.line_price === 0 ? 'מתנה' : money(it.line_price / 100);
        row.appendChild(price);

        box.appendChild(row);
      });

      if ((cart.items || []).length > 4) {
        var more = document.createElement('div');
        more.className = 'ola-basket__more';
        more.textContent = 'ועוד ' + (cart.items.length - 4);
        box.appendChild(more);
      }

      var total = document.createElement('div');
      total.className = 'ola-basket__total';
      total.appendChild(document.createTextNode('סך הכול'));
      var sum = document.createElement('b');
      sum.textContent = money(cart.total_price / 100);
      total.appendChild(sum);
      box.appendChild(total);

      var go = document.createElement('a');
      go.className = 'ola-basket__go';
      go.href = '/checkout';
      go.textContent = 'מעבר לתשלום';
      box.appendChild(go);

      log.appendChild(box);
      scrollDown();
    }

    async function cartNow() {
      try {
        var r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        var c = await r.json();
        lastCartCount = (c && c.item_count) || 0;
        return c;
      } catch (e) { return null; }
    }

    /* The theme listens on three different events and each does a different job:
       cart:updated redraws the header count, cart:refresh redraws the drawer's item
       list, cart:item-added is what the free gift rule waits for. Announcing only the
       first one leaves the item in her cart but missing from the screen. */
    function announceCart() {
      /* ORDER MATTERS HERE, AND IT WAS THE WRONG WAY ROUND.

         free-gift.js runs a clean-only pass on cart:updated and the pass that actually adds
         the present on cart:item-added, and it holds a `busy` flag across its own fetch. So
         announcing cart:updated first started the clean pass, the clean pass took the flag,
         and the add pass was dropped on arrival. She added a product from the advisor, the
         drawer opened without the free Velvet Puff, and if she checked out from the drawer
         the order shipped without it. Every other add path in the theme fires item-added
         first; this one now does too. */
      document.dispatchEvent(new CustomEvent('cart:item-added'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));

      // The /cart page is server rendered and nothing on it listens for a change, so an
      // item added from here would sit in her cart and be missing from the page in front
      // of her. Re-render the section rather than reloading, so the conversation survives.
      if (/^\/cart\/?$/.test(location.pathname)) {
        fetch('/cart?section_id=main-cart', { headers: { Accept: 'text/html' }, cache: 'no-store' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var fresh = new DOMParser().parseFromString(html, 'text/html')
              .querySelector('.shopify-section, #MainCart, [id^="shopify-section"]');
            var liveEl = document.querySelector('#MainCart')
              || document.querySelector('[id^="shopify-section"][id*="main-cart"]');
            if (fresh && liveEl) liveEl.replaceChildren.apply(liveEl, Array.from(fresh.childNodes));
          })
          .catch(function () { /* the cart itself is correct either way */ });
      }
    }

    async function addVariant(variantId) {
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      if (!r.ok) throw new Error(String(r.status));
      var out = await r.json();
      announceCart();
      refreshShipping();
      return out;
    }

    async function addFromCard(button, p) {
      if (button.disabled) return;
      var original = button.textContent;
      button.disabled = true;
      button.textContent = 'מוסיפה';
      try {
        var out = await addVariant(p.variantId);
        button.textContent = '✓ נוסף לסל';
        var row = button.parentNode;
        if (row && !row.querySelector('[data-agent-checkout]')) {
          var go = document.createElement('a');
          go.className = 'ola-card__link';
          var onCart = pageContext().template === 'cart';
          go.href = onCart ? '/checkout' : '/cart';
          go.textContent = onCart ? 'מעבר לתשלום' : 'לתשלום';
          go.setAttribute('data-agent-checkout', '');
          row.appendChild(go);
        }
        /* Reported last, and the order is the promise: counting happens only after Shopify
           confirmed the add and after she has seen the button say so. The beacon itself is
           fire and forget, so nothing the funnel does can sit between her tap and her
           confirmation, not even the JSON.

           The button is inside the card that produced it in both call sites, the answer's
           card and the product page's hero, so the provenance is read off the DOM rather
           than passed down a second argument that a third call site could forget. A button
           with no stamp above it reports 'unknown' and is not attributed: that is a bug
           made visible in the log instead of a mislabelled add. */
        var v = addedValue(out);
        var o = cardOrigin(button);
        track('add_to_cart', {
          src: o ? o.src : 'unknown',
          age: o ? o.age : null,
          agent: fromAgent(o),
          value: v.value,
          n: v.n,
        });
      } catch (e) {
        // Shopify is the authority on whether something can be bought. If it says no,
        // say no; do not leave a button claiming success.
        button.disabled = false;
        button.textContent = original;
        bubble('לא הצלחתי להוסיף את ' + p.title + ' לסל. ייתכן שזה אזל בדיוק עכשיו.', 'bot');
      }
    }

    /* A reset has to cancel the answer that is already on its way. Without this she pressed
       "להתחיל שיחה חדשה", got a clean greeting, and then a paragraph about a product she no
       longer had a question in front of appeared on its own, with product cards, and was
       written into the fresh thread's history. The counter is what makes a late answer
       recognisable as belonging to a conversation that no longer exists. */
    var inflight = null;
    var turnSeq = 0;

    async function ask(text) {
      if (busy || !text) return;
      var turn = ++turnSeq;
      busy = true;
      send.disabled = true;
      suggestBox.textContent = '';
      /* The shelf stays. It used to be removed the moment she asked her first question,
         so a shopper who opened on the home page, tapped one product and then wanted
         another had nothing to go back to: the other five were gone and the only way to
         reach them was to type the name. It is part of the conversation, so it scrolls
         with it. */
      bubble(text, 'me');
      input.value = '';
      typing(true);
      track('ask');

      var gathered = await Promise.all([cartNow(), reviewsNow()]);
      var payload = {
        message: text,
        history: history.slice(-10),
        page: pageContext(),
        cart: gathered[0],
        reviews: gathered[1],
        sessionId: sessionId,
        returning: returning,
      };

      /* Twenty five seconds and then it is over, one way or the other. A fetch with no
         timeout can hang until the tab is closed, and what she sees while it hangs is a
         typing indicator that never stops: the shop looks broken and she has no way to
         tell whether her question arrived. */
      var abort = new AbortController();
      inflight = abort;
      var timer = setTimeout(function () { abort.abort(); }, 25000);

      try {
        var res = await fetch(endpoint + '/chat', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          signal: abort.signal,
        });
        var doc = await res.json().catch(function () { return {}; });
        if (turn !== turnSeq) return;          // she reset while this was in the air
        typing(false);
        // A server that answered with an error is not the shopper phrasing her question
        // badly, and telling her to rephrase would send her in circles.
        if (!res.ok && !doc.text) {
          bubble('היועצת לא זמינה כרגע.', 'bot');
          renderHandoff(localHandoff(text, 'נציגה אנושית כן זמינה ותענה לך עכשיו.'));
          return;
        }
        var answer = doc.text || 'לא הצלחתי לענות על זה. אפשר לנסות לנסח אחרת?';
        var answerEl = bubble(answer, 'bot');
        if (doc.showCart) renderCartCard(await cartNow());
        renderCards(doc.products);
        renderHandoff(doc.handoff);
        // Written by the advisor for this answer, so they follow the thread instead of
        // resetting it to the same three openers every turn.
        if (doc.followups && doc.followups.length) chips(doc.followups);
        /* Last, after the cards and the chips have been appended, so the measurement is
           taken against the finished answer rather than against half of it. */
        scrollToAnswer(answerEl);
        history.push({ role: 'user', content: text });
        history.push({ role: 'assistant', content: answer });
        saveThread();

        // The one action taken without a tap, and it happens here, in her browser, in
        // her own session, where she can see it and undo it.
        if (doc.action && doc.action.type === 'add_to_cart') {
          try {
            var actionOut = await addVariant(doc.action.variant);
            var el = bubble('הוספתי לסל: ' + doc.action.title + '. ', 'bot');
            var a = document.createElement('a');
            a.href = '/cart';
            a.textContent = 'לצפייה בסל';
            el.appendChild(a);
            /* The advisor did this itself, in this turn, so there is no card to measure
               against and no window to miss: the age is zero by construction. This is the
               most attributable add the system can produce, and it still goes through
               fromAgent rather than asserting true, so there stays exactly one definition
               of what counts. */
            var actionValue = addedValue(actionOut);
            var actionOrigin = { src: 'action', age: 0 };
            track('add_to_cart', {
              src: actionOrigin.src,
              age: actionOrigin.age,
              agent: fromAgent(actionOrigin),
              value: actionValue.value,
              n: actionValue.n,
            });
          } catch (e2) {
            bubble('לא הצלחתי להוסיף את זה לסל. ייתכן שזה אזל בדיוק עכשיו.', 'bot');
          }
        }
      } catch (e) {
        typing(false);
        bubble(
          e && e.name === 'AbortError'
            ? 'זה לקח יותר מדי זמן ואני לא רוצה להשאיר אותך מחכה.'
            : 'לא הצלחתי להתחבר כרגע.',
          'bot'
        );
        renderHandoff(localHandoff(text, 'נציגה אנושית זמינה ותענה לך עכשיו.'));
      } finally {
        clearTimeout(timer);
        busy = false;
        send.disabled = false;
        typing(false);
        input.focus();
      }
    }

    /* The opening.
       On a product page the advisor already knows what she is looking at, so it says so
       and puts the card in front of her immediately, with the price Shopify printed and a
       button that works before any request is made. Asking "מה תרצי לדעת" while she stands
       in front of one product wastes the one moment she was willing to give it.
       Everywhere else she is choosing, so she gets the shelf. */
    /* Everything the advisor can say about the product she is standing on WITHOUT asking the
       model: the shop's own hook, the live card from the page itself, and the three
       questions that product actually raises. It costs nothing, which is why it can run on
       every page change instead of only when she types. */
    function orientToProduct(lead) {
      var title = root.dataset.productTitle;
      var hook = root.dataset.hook;
      var hookSub = root.dataset.hookSub;
      if (!title) return false;

      if (root.dataset.soldOut === '1') {
        bubble(lead + title + ' אזל כרגע.\nבדף המוצר יש טופס קצר ומי שנרשמת מקבלת הודעה כשהוא חוזר.', 'bot');
        chips(['מה הכי דומה לזה?', 'מתי הוא חוזר?', 'מה יש במארזים?']);
        return true;
      }

      /* The lead belongs to the fallback sentence only. The hooks are noun phrases written
         for a teaser, "ארבע מברשות במברשת אחת", so gluing "אני רואה ש" onto one produces a
         sentence with no verb. */
      bubble(
        (hook ? hook + '.' : lead + 'את מסתכלת על ' + title + '.') +
          (hookSub ? '\n' + hookSub + (/[.!?]$/.test(hookSub) ? '' : '.') : '') +
          /* Not "עוד עליו". The hook branch deliberately drops the title, so the pronoun
             refers to nothing that was said, and half the catalogue is feminine in Hebrew:
             מברשת, ספוגית, מהדורה. Dropping it is correct for every product and needs no
             gender table. */
          '\nרוצה לדעת עוד, או שאני אעזור לך להחליט?',
        'bot'
      );
      if (heroProductTpl) {
        var card = heroProductTpl.content.cloneNode(true);
        var add = card.querySelector('[data-agent-hero-add]');
        if (add) {
          add.addEventListener('click', function () {
            addFromCard(add, {
              variantId: add.getAttribute('data-agent-hero-add'),
              title: add.getAttribute('data-agent-hero-title'),
            });
          });
        }
        /* Stamped 'hero', counted separately, and never attributed to the advisor.
           This card is the product she was already standing on, printed by Liquid before a
           single word was exchanged. An add from it is a panel assisted add, not one the
           advisor earned, and the honest report of it is a category of its own rather than
           silence: the gap between the two numbers is itself the thing worth watching.
           Before the append, because appendChild empties the fragment. */
        stampCard(card.querySelector('.ola-card'), 'hero');
        log.appendChild(card);
        scrollDown();
        track('cards_shown', { src: 'hero', n: 1 });
      }
      chips(['איך משתמשים בזה?', 'זה מתאים לי?', 'מה ההבדל מהמארז?']);
      return true;
    }

    function greet() {
      var ctx = pageContext();
      var title = root.dataset.productTitle;
      var hook = root.dataset.hook;
      var hookSub = root.dataset.hookSub;
      var soldOut = root.dataset.soldOut === '1';

      /* The basket first, wherever she is.
         A shopper on /cart with a full basket was being greeted with "on what would you
         like to hear" and shown six other products, at the one moment in the whole shop
         where a distraction costs an order. */
      if (ctx.template === 'cart' && lastCartCount > 0) {
        bubble('הסל שלך מוכן. אם יש משהו שאת רוצה לוודא לפני שאת סוגרת, אני כאן.', 'bot');
        cartNow().then(renderCartCard);
        /* Not "מה חסר לי", which hands her a deficit to close, and not "איפה ההזמנה
           שלי", which she cannot have on the page where she has not ordered yet. Both
           chips now ask what she gains, which is the same ladder every offer here uses. */
        chips(['מה שווה לי לשדרג בסל?', 'יש מארז שמשתלם לי יותר?', 'מתי זה מגיע?']);
        return;
      }

      if (ctx.product && title && orientToProduct(soldOut ? '' : 'אני רואה ש')) return;

      bubble(
        returning ? 'שמחה לראות אותך שוב. במה אפשר לעזור?' : 'היי, אני היועצת של אולה.\nעל מה תרצי לשמוע?',
        'bot'
      );
      if (heroHomeTpl) {
        var hero = heroHomeTpl.content.cloneNode(true);
        Array.prototype.forEach.call(hero.querySelectorAll('[data-agent-ask]'), function (tile) {
          tile.addEventListener('click', function () { ask(tile.getAttribute('data-agent-ask')); });
        });
        log.appendChild(hero);
        scrollDown();
      }
      chips(['מה הכי מתאים לי?', 'מה יש במארזים?', 'איפה ההזמנה שלי?']);
    }

    function open() {
      panel.hidden = false;
      root.classList.add('ola-agent--open');
      root.querySelector('[data-agent-open]').setAttribute('aria-expanded', 'true');
      hideTeaser(true);
      track('open');
      try { sessionStorage.setItem(OPEN_KEY, '1'); } catch (e) {}
      /* Awaited, not fired and forgotten: greet() decides what to say from the basket,
         and lastCartCount was still zero when it ran. */
      refreshShipping().catch(function () {}).then(function () {
        if (!log.children.length && !history.length) greet();
      });

      if (!log.children.length && !history.length) {
        var prior = loadThread();
        if (prior.length) {
          history = prior;
          /* The opening is redrawn first. Without it a restored thread began mid
             sentence, with no greeting and, on a non product page, no shelf, so the
             panel looked like it had lost her place. */
          var ctx0 = pageContext();
          var moved = lastPageMark() && lastPageMark() !== pageMark();
          var onCartNow = ctx0.template === 'cart' && lastCartCount > 0;
          bubble(
            ctx0.product && root.dataset.productTitle
              ? (moved ? 'המשכנו. עברת ל-' : 'חזרנו. את על ') + root.dataset.productTitle + '.'
              : onCartNow
                ? 'חזרנו, והסל שלך מוכן. אם יש משהו לוודא לפני שאת סוגרת, אני כאן.'
                : 'חזרנו. הנה מה שדיברנו עליו.',
            'bot'
          );
          if (onCartNow) cartNow().then(renderCartCard);
          /* greet() has a cart branch because a shopper on /cart with a full basket was
             being shown six other products at the one moment where a distraction costs an
             order. The restore path never got that fix: a conversation carried onto /cart
             reopened with the shelf and with "איפה ההזמנה שלי?", which is a question she
             cannot have yet. */
          var onCartWithItems = ctx0.template === 'cart' && lastCartCount > 0;
          if (heroHomeTpl && !ctx0.product && !onCartWithItems) {
            var backHero = heroHomeTpl.content.cloneNode(true);
            Array.prototype.forEach.call(backHero.querySelectorAll('[data-agent-ask]'), function (tile) {
              tile.addEventListener('click', function () { ask(tile.getAttribute('data-agent-ask')); });
            });
            log.appendChild(backHero);
          }
          prior.forEach(function (turn) {
            bubble(turn.content, turn.role === 'user' ? 'me' : 'bot');
          });
          /* A restored thread used to arrive with no suggestions at all, so the panel
             opened onto a wall of old text from another page and nothing to tap.
             And when she has walked from one product to another mid conversation, the
             advisor should notice where she is standing now rather than carry on about the
             last one. The whole orientation is built from the page she is already looking
             at, so following her costs nothing and happens once per arrival, not per turn. */
          var c = pageContext();
          if (moved && c.product && orientToProduct('')) {
            /* orientToProduct drew the card and the chips. */
          } else {
            chips(
              c.product
                ? ['מה זה בדיוק?', 'איך משתמשים בזה?', 'יש את זה במלאי?']
                : onCartWithItems
                  ? ['מה שווה לי לשדרג בסל?', 'יש מארז שמשתלם לי יותר?', 'מתי זה מגיע?']
                  : ['מה הכי מתאים לי?', 'מה יש במארזים?', 'איפה ההזמנה שלי?']
            );
          }
        }
      }

      /* NOT greeted here. The call eleven lines up is deliberately inside
         refreshShipping().then, so that lastCartCount is fresh when greet() decides what
         to say; this one ran a whole network round trip earlier and always won. So greet()
         read a basket of zero, and a shopper standing on /cart with a full basket was
         greeted with "על מה תרצי לשמוע?" and a shelf of six products, at the one step where
         a distraction costs the order. The awaited call is made fault tolerant instead, so
         a failed shipping read cannot swallow the greeting. */
      rememberPage();
      setTimeout(function () { input.focus(); }, 60);
    }

    /* She was mid conversation and clicked through to another product. A page change on
       Shopify is a full reload, so without this the advisor closes itself in the middle of
       the exchange and she has to go looking for the bubble again. Only for someone who
       actually talked: a panel that was opened and abandoned does not follow her around,
       and checkout is left alone entirely. */
    function reopenIfSheWasTalking() {
      var wasOpen = false;
      try { wasOpen = sessionStorage.getItem(OPEN_KEY) === '1'; } catch (e) {}
      if (!wasOpen) return;
      if (pageContext().template === 'checkout') return;
      if (!loadThread().length) return;
      open();
    }

    function close() {
      panel.hidden = true;
      root.classList.remove('ola-agent--open');
      try { sessionStorage.setItem(OPEN_KEY, '0'); } catch (e) {}
      var launcher = root.querySelector('[data-agent-open]');
      launcher.setAttribute('aria-expanded', 'false');
      // Without this, closing drops the keyboard to the top of the document and someone
      // tabbing through the page has to walk the whole shop again to reach the bubble.
      try { launcher.focus(); } catch (e) {}
    }

    /* The teaser.
       A Flashy modal already fires at three seconds for non-subscribers, so this waits
       until that moment has passed and she is still reading. Once per session, never on
       the cart or a page where another overlay is up, and dismissing it is remembered. */
    /* Once per product, not once per visit.
       The first version remembered a single flag, so the teaser appeared on the first
       product page she opened and never again. That was right when every page said the
       same sentence. Now each product has its own line, and the line about the brow gel
       is the reason to look at the brow gel, so suppressing it because she already saw
       the one about the tanning cream throws away the whole point.

       Two limits keep it from nagging: a product she has already been shown does not
       repeat, and three in a session is the most she will ever see. Closing one with the
       X is a clear no and silences all of them. */
    var TEASER_KEY = 'olaAgentTeaser';
    var TEASER_COUNT_KEY = 'olaAgentTeaserCount';
    var TEASER_MAX = 3;

    function teaserKeyForPage() {
      var ctx = pageContext();
      return TEASER_KEY + ':' + (ctx.product || ctx.template || 'page');
    }

    function teaserCount() {
      try { return parseInt(sessionStorage.getItem(TEASER_COUNT_KEY), 10) || 0; } catch (e) { return 0; }
    }

    function hideTeaser(remember) {
      if (teaser) teaser.hidden = true;
      if (!remember) return;
      try { sessionStorage.setItem(teaserKeyForPage(), '1'); } catch (e) {}
    }

    /* The X is different from opening the chat. Opening it means "not this one, I am in";
       the X means "stop showing me these", and it is honoured for the rest of the visit. */
    function silenceAllTeasers() {
      if (teaser) teaser.hidden = true;
      try { sessionStorage.setItem(TEASER_KEY + ':all', '1'); } catch (e) {}
    }

    function overlayUp() {
      return !!document.querySelector(
        '.cart-drawer--open, .ingredients-modal.is-open, [class*="flashy"][class*="open"], dialog[open]'
      ) || document.body.classList.contains('cart-open');
    }

    function maybeTeaser() {
      if (!teaser) return;
      var silenced = false;
      var seenThis = false;
      try {
        silenced = sessionStorage.getItem(TEASER_KEY + ':all') === '1';
        seenThis = sessionStorage.getItem(teaserKeyForPage()) === '1';
      } catch (e) {}
      if (silenced || seenThis) return;
      if (teaserCount() >= TEASER_MAX) return;
      /* The cart page used to be excluded entirely, which removed the teaser from the
         one page where a shopper leaving is worth the most. Checkout stays excluded; it
         is a different origin and not ours to interrupt. */
      if (/^\/checkouts?\/?/.test(location.pathname)) return;
      if (/^\/cart\/?/.test(location.pathname) && lastCartCount === 0) return;
      if (!panel.hidden || overlayUp()) return;

      /* On the cart page the line names her own basket. "משהו עוצר אותך?" is ignorable;
         "שני פריטים בסל, משהו עוצר אותך?" is about her. */
      var cartLine = teaser.querySelector('[data-agent-teaser-cartline]');
      if (cartLine && lastCartCount > 0) {
        cartLine.textContent =
          (lastCartCount === 1 ? 'פריט אחד בסל' : lastCartCount + ' פריטים בסל') + '. משהו עוצר אותך?';
      }
      teaser.hidden = false;
      track('teaser_shown');
      try {
        sessionStorage.setItem(teaserKeyForPage(), '1');
        sessionStorage.setItem(TEASER_COUNT_KEY, String(teaserCount() + 1));
      } catch (e) {}
    }

    /* The basket count, read once on load.
       The cart page teaser was gated on lastCartCount, which is only set when the panel
       is opened, so on the one page where the teaser matters most it was always
       suppressed. One cheap request fixes both the gate and the sentence. */
    if (teaser) {
      cartNow().catch(function () {});
    }

    if (teaser) {
      root.querySelector('[data-agent-teaser-open]').addEventListener('click', function () {
        var q = teaser.getAttribute('data-agent-teaser-ask');
        hideTeaser(true);
        open();
        // On a product page the teaser is already a question, so tapping it should ask
        // that question rather than dropping her into an empty box to retype it.
        if (q) ask(q);
      });
      root.querySelector('[data-agent-teaser-close]').addEventListener('click', silenceAllTeasers);
      /* When to speak.
         A timer alone is the weakest trigger there is: it fires on someone who arrived by
         accident and has already decided to leave, and it fires at the same moment whether
         she is reading or scrolling past. Engagement is the better signal, so the bubble
         waits for one of three things and takes whichever comes first.

         1. She scrolled a third of the page. She is reading.
         2. She has been here long enough that a question has had time to form.
         3. Her cursor left through the top of the window, which on a desktop is the
            gesture of leaving. This is the last moment the shop has, and it is the one
            moment where an interruption costs nothing.

         Whichever fires, it fires once. */
      var teaserArmed = true;
      function fireTeaser() {
        if (!teaserArmed) return;
        teaserArmed = false;
        maybeTeaser();
      }

      var onScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && window.scrollY / h > 0.33) fireTeaser();
      };
      window.addEventListener('scroll', onScroll, { passive: true });

      var onExit = function (e) {
        if (e.clientY <= 0) fireTeaser();
      };
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        document.addEventListener('mouseout', onExit);
      }

      setTimeout(fireTeaser, pageContext().product ? 20000 : 35000);
    }

    document.addEventListener('cart:updated', refreshShipping);

    /* A card tapped, by delegation on the log rather than on each anchor.

       Delegation because cards are built in two places already and a third would be easy
       to wire and easier to forget, and because a listener attached once to the container
       cannot be attached twice to a card that is redrawn.

       This is the stage BEFORE the add and disjoint from it: a tap here means she left the
       panel for the product page, an add means she bought from inside it. Keeping the two
       disjoint is what stops the funnel counting one shopper as two.

       cardOrigin returning null is the filter. A link inside an answer's own text, the
       order tracking link among them, is not inside a stamped card and produces nothing.
       The checkout link is skipped explicitly because it is appended INTO a card after a
       successful add, so counting it would report the same add a second time as a tap.

       Nothing here calls preventDefault and nothing here is awaited, so the navigation
       leaves at exactly the speed it did before. keepalive on the beacon is what carries
       it across that navigation, which is the whole reason the tap is measurable at all. */
    log.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a') : null;
      if (!a || a.hasAttribute('data-agent-checkout')) return;
      var o = cardOrigin(a);
      if (!o) return;
      track('card_tap', { src: o.src, age: o.age, agent: fromAgent(o) });
    });

    root.querySelector('[data-agent-open]').addEventListener('click', open);
    root.querySelector('[data-agent-close]').addEventListener('click', close);
    root.querySelector('[data-agent-reset]').addEventListener('click', resetThread);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) close();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      ask(input.value.trim());
    });

    /* Last, so every handler above is wired before the panel can draw itself. */
    reopenIfSheWasTalking();
  })();
